import { SortOrder } from 'shared/types/query/OrderQuery';

const SearchSortOrder = {
  ASC: 'asc',
  DESC: 'desc',
};

/**
 * Prepare sort parameters in Nosto format from query
 * Usage: request to Nosto
 *
 * @param query
 */
export const getSorting = (query) => {
  const sortMap = {
    'variants.scopedPrice.value.centAmount': 'price',
    'variants.attributes.currentsalepriceaud': 'price',
    'variants.attributes.currentsalepricenzd': 'price',
    'variants.attributes.onlinefromdate': 'customFields.onlinefromdate',
  };
  const sort = [];

  if (query.sortAttributes !== undefined) {
    Object.entries(query.sortAttributes).map(([field, order]) => {
      const sortField = {
        field: sortMap[field],
        order: order === SortOrder.ASCENDING ? SearchSortOrder.ASC : SearchSortOrder.DESC,
      };

      if (sortField.field) {
        sort.push(sortField);
      }
    });
  }

  return sort;
};

/**
 * Prepare filters in Nosto format from query
 * Usage: request to Nosto
 *
 * @param query
 */
export const getNostoFilters = (query) => {
  if (!query.facets) {
    return [];
  }

  return query.facets
    .filter((facet) => 'terms' in facet)
    .map((facet) => ({
      field: findKeyByValue(nostoToCtFacetMap, facet.identifier),
      value: facet.terms,
    }));
};

const nostoToCtFacetMap = {
  tags1: 'variants.attributes.size',
  'customFields.refinementcolour': 'variants.attributes.refinementcolour',
};

const findKeyByValue = (map, searchValue) => {
  const foundEntry = Object.entries(map).find(([_, value]) => value === searchValue);
  return foundEntry ? foundEntry[0] : undefined;
};
